(ns ballot-scout-v2-frontend.resources.events
  (:require
   [ajax.edn :as a.edn]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::fetch-resource-urls
 (fn [_ _]
   {::events/ajax {:method :get
                   :uri (urls/resource-urls)
                   :format (a.edn/edn-request-format)
                   :response-format (a.edn/edn-response-format)
                   :on-success [::fetch-resource-urls-success]
                   :on-failure [::fetch-resource-urls-failure]}}))

(rf/reg-event-fx
 ::fetch-resource-urls-success
 (fn [{:keys [db]} [_ response]]
   {:db (assoc db :resource-urls response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-resource-urls]]}))

(rf/reg-event-fx
 ::fetch-resource-urls-failure
 (fn [_ [_ response]]
   {:dispatch [::request-helpers/request-failed [::fetch-resource-urls] response]}))
